import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { ListProjectsResponse } from '@xver/apis/v1/sammeln/projects/model';

export const PROJECTS_LIST_QUERY_KEY = ['apis.v1.sammeln.projects.list'];

export function useProjectsListQuery() {
    return useQuery<ListProjectsResponse>({
        queryKey: PROJECTS_LIST_QUERY_KEY,
        queryFn: Endpoints.v1.Sammeln.Projects.listProjects,
        staleTime: 0,
        refetchOnMount: 'always',
        refetchOnWindowFocus: 'always',
    });
}
